import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getPost, deletePost } from '../api/posts';

const Post = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [post, setPost] = useState(null);

    useEffect(() => {
        getPost(id).then(setPost).catch(console.error);
    }, [id]);

    const handleDelete = async () => {
        await deletePost(id);
        navigate('/');
    };

    if (!post) return <div>Loading...</div>;

    return (
        <div className="card">
            <div className="page-header" style={{ marginBottom: '1rem' }}>
                <h1 style={{ marginBottom: 0 }}>{post.title}</h1>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <Link to={`/edit/${post.id}`} className="btn btn-secondary">Edit</Link>
                    <button onClick={handleDelete} className="btn btn-danger">Delete</button>
                </div>
            </div>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.7', whiteSpace: 'pre-wrap', color: 'var(--text-secondary)' }}>
                {post.content}
            </p>
            <div style={{ marginTop: '2rem', borderTop: '1px solid var(--border)', paddingTop: '1rem' }}>
                <Link to="/" style={{ color: 'var(--primary)', fontWeight: 500 }}>← Back to Home</Link>
            </div>
        </div>
    );
};

export default Post;
